<template>
    <div v-if="isVisible" class="modal-overlay">
        <div class="modal-content">
            <!-- 步驟一：選擇商品種類 -->
            <div v-if="currentStep === 'selectKind'">
                <h2>選擇商品種類</h2>
                <div class="form-group">
                    <label for="productKind">商品種類:</label>
                    <select id="productKind" v-model="selectedKind" style="width: 100%; padding: 10px; border: 1px solid #ccc; border-radius: 4px; font-size: 1em;">
                        <option v-for="kind in AllKind" :key="kind.value" :value="kind.value">
                            {{ kind.label }}
                        </option>
                    </select>
                </div>
                <div class="modal-actions" style="justify-content: space-between;">
                    <button type="button" class="btn btn-cancel" @click="closeModal">取消</button>
                    <button type="button" class="btn btn-save" @click="goToFillFormStep" :disabled="!selectedKind">下一步</button>
                </div>
            </div>

            <!-- 步驟二：填寫商品詳情 (原有表單) -->
            <div v-if="currentStep === 'fillForm'">
                <h2>新增商品 - {{ AllKind.find(k => k.value === product.kind)?.label }}</h2>
                <form @submit.prevent="handleSubmit">
                    <div class="form-layout-container">
                        <div class="form-left-panel">
                            <div class="form-group">
                                <label for="productImages">商品圖片 (可多選，請選擇一張作爲封面):</label>
                                <input type="file" id="productImages" @change="handleFileChange" multiple accept="image/*">
                                <div v-if="product.images && product.images.length > 0" class="image-preview-container">
                                    <div v-for="(image, index) in product.images" :key="index" class="image-preview-item">
                                        <img :src="image.previewUrl" :alt="'預覽 ' + (index + 1)" class="preview-thumbnail">
                                        <div class="image-actions">
                                            <label :for="'cover-' + index" class="cover-label">
                                                <input
                                                    type="radio"
                                                    :id="'cover-' + index"
                                                    name="coverImage"
                                                    :value="image.file.name"
                                                    v-model="product.mainImage"
                                                    @change="setAsCover(image)"
                                                > 封面
                                            </label>
                                            <button type="button" @click="removeImage(index)" class="btn-remove-img">×</button>
                                        </div>
                                    </div>
                                </div>
                                <p v-if="product.images && product.images.length > 0 && !product.mainImage" class="cover-warning">
                                    請選擇一張圖片作爲封面圖！
                                </p>
                            </div>
                        </div>

                        <div class="form-right-panel">
                            <div class="form-group">
                                <label for="productName">商品名稱（標題）:</label>
                                <input type="text" id="productName" v-model="product.name" required>
                            </div>
                            <div class="form-group">
                                <label for="productBrand">品牌名稱:</label>
                                <input type="text" id="productBrand" v-model.trim="product.brandName" placeholder="輸入品牌名稱..." required>
                            </div>
                            <div class="form-group">
                                <label for="productGender">適用性別:</label>
                                <select id="productGender" v-model="product.gender">
                                    <option v-for="genderItem in GenderOptions" :key="genderItem.value" :value="genderItem.value">
                                        {{ genderItem.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="productModel">商品型號:</label>
                                <input type="text" id="productModel" v-model="product.model" placeholder="輸入商品型號...">
                            </div>
                            <div class="form-group">
                                <label for="productPrice">一般價 (元):</label>
                                <input type="number" id="productPrice" v-model.number="product.normal_price" step="0.01" required>
                            </div>
                            <div class="form-group">
                                <label for="productPrice">會員價 (元):</label>
                                <input type="number" id="productPrice" v-model.number="product.price" step="0.01" required>
                            </div>
                            <div class="form-group">
                                <label for="productStatus">狀態:</label>
                                <select id="productStatus" v-model="product.status" required>
                                    <option value="on">上架中</option>
                                    <option value="off">已下架</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="productDescription">商品介紹:</label>
                                <textarea id="productDescription" v-model="product.description" rows="4" placeholder="輸入商品詳細介紹..."></textarea>
                            </div>
                            <div class="form-group">
                                <label>商品尺碼和庫存:</label>
                                <div class="shoe-size-input-group">
                                    <input type="text" v-model.trim="newShoeSize.size" placeholder="輸入尺碼 (如: 42)" class="shoe-size-field">
                                    <input type="number" v-model.number="newShoeSize.stock" placeholder="庫存" min="0" class="shoe-stock-field">
                                    <button type="button" @click="addShoeSize" class="btn btn-add-size">添加尺碼</button>
                                </div>
                                <div v-if="product.shoeSizes && product.shoeSizes.length > 0" class="shoe-size-list">
                                    <strong>已添加尺碼:</strong>
                                    <ul>
                                        <li v-for="(item, index) in product.shoeSizes" :key="index" class="shoe-size-list-item">
                                            <span>尺碼: {{ item.size }} - 庫存: </span>
                                            <input
                                                type="number"
                                                v-model.number="item.stock"
                                                min="0"
                                                class="shoe-size-list-stock-input"
                                                @blur="validateStock(item)"
                                            >
                                            <button type="button" @click="removeShoeSize(index)" class="btn-remove-size">×</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="productTags">標簽 (逗號分隔):</label>
                                <input type="text" id="productTags" v-model="tagsInput" placeholder="新品,熱賣">
                            </div>
                        </div>
                    </div>
                    
                    <div class="modal-actions">
                        <button type="button" class="btn btn-secondary" @click="goToSelectKindStep">上一步</button>
                        <button type="button" class="btn btn-cancel" @click="closeModal">取消</button>
                        <button type="submit" class="btn btn-save" :disabled="isSaveDisabled">保存新增</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, computed } from 'vue';
import { ElMessage } from 'element-plus'

const props = defineProps({
    isVisible: Boolean
    // categoriesList 和 brandsList props 已移除
});

const emit = defineEmits(['close', 'save']);

const AllKind = [
  { label: '水槽&洗碗槽', value: 'sink_and_dishwasher' },
  { label: '花架&花盆', value: 'flower_stand_and_pot' },
  { label: '床頭靠墊/床頭軟包', value: 'bed_head_cushion' },
  { label: '山水畫', value: 'landscape_painting' },
  { label: '塌塌米豆帶沙發', value: 'tatami_sofa' },
  { label: '長凳子/長條椅', value: 'bench' },
  { label: '角鋼架/貨架', value: 'steel_shelf' },
  { label: '貓爬架/貓窩/貓屋', value: 'cat_tree_and_house' },
  { label: '戶外沙發', value: 'outdoor_sofa' },
  { label: '人台/服裝模特', value: 'mannequin' },
  { label: '蚊帳', value: 'mosquito_net' },
  { label: '健身器材', value: 'fitness_equipment' },
  { label: '衣櫥/衣櫃/衣架', value: 'wardrobe_and_rack' },
  { label: '鏡櫃', value: 'mirror_cabinet' },
  { label: '沙發/電腦椅/長椅', value: 'sofa_and_chair' },
  { label: '汽車配件', value: 'automotive_parts' },
];

const GenderOptions = [
  {label: '男士',value: 'men'},
  {label: '女士',value:'female'},
  {label: '情侶',value:'neutral'}
];

const currentStep = ref('selectKind'); // 'selectKind' or 'fillForm'
const selectedKind = ref(AllKind[0].value); // 默認選中第一個，確保有值

const defaultProductState = () => ({
    kind: '', // 新增商品種類字段
    name: '',
    // categoryId: '', // 移除
    brandName: '',    // 改为 brandName
    gender: '',
    model: '', 
    normal_price: 0,
    price: 0,
    status: 'on',
    mainImage: '',
    images: [],
    description: '', 
    tags: [],
    shoeSizes: [] 
});

const product = ref(defaultProductState());
const tagsInput = ref('');
const newShoeSize = ref({ size: '', stock: 0 });

watch(() => props.isVisible, (newValue) => {
    if (newValue) {
        currentStep.value = 'selectKind'; // 重置到第一步
        selectedKind.value = AllKind[0].value; // 重置選擇的種類
        product.value = defaultProductState();
        tagsInput.value = '';
        newShoeSize.value = { size: '', stock: 0 }; 
    }
});

const goToFillFormStep = () => {
    if (!selectedKind.value) {
        ElMessage.warning("請選擇商品種類！");
        return;
    }
    product.value.kind = selectedKind.value; // 將選擇的種類賦值給 product
    currentStep.value = 'fillForm';
};

const goToSelectKindStep = () => {
    currentStep.value = 'selectKind';
    // 此處不重置表單數據，允許用戶返回修改種類後，若再前進，之前填寫的數據（除kind外）仍在
    // 完整的表單重置由 watch isVisible 或 closeModal -> isVisible=false -> watch 觸發
};

const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    files.forEach(file => {

        if (file.name.includes(',') || file.name.includes('，')) {
            ElMessage.warning(`文件名 "${file.name}" 不能包含逗号 ("," 或 "，")。请修改文件名后重新上传。`);
            return; // 阻止此文件的后续处理
        }

        // 文件验证
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/jfif']
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (!allowedTypes.includes(file.type)) {
            ElMessage.warning(`文件類型 ${file.name} 不支持。請上傳 JPEG, PNG, JPG, JFIF 格式的圖片。`);
            return;
        }
        if (file.size > maxSize) {
            ElMessage.warning(`文件 ${file.name} 大小超過限制 (5MB)。`);
            return; 
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            product.value.images.push({ file: file, previewUrl: e.target.result });
            if (product.value.images.length === 1) {
                product.value.mainImage = file.name;
            }
        };
        reader.readAsDataURL(file);
    });
    event.target.value = null;
};

const setAsCover = (selectedImage) => {
    product.value.mainImage = selectedImage.file.name;
};

const removeImage = (indexToRemove) => {
    const removedImage = product.value.images[indexToRemove];
    product.value.images.splice(indexToRemove, 1);
    if (product.value.mainImage === removedImage.file.name) {
        product.value.mainImage = '';
        if (product.value.images.length > 0) {
            product.value.mainImage = product.value.images[0].file.name;
        }
    }
};

const addShoeSize = () => {
    const size = newShoeSize.value.size;
    const stock = newShoeSize.value.stock;

    if (!size) {
        ElMessage.warning("請輸入尺碼！");
        return;
    }
    if (stock < 0 || stock === null || stock === undefined || isNaN(stock)) {
        newShoeSize.value.stock = 0;
        ElMessage.warning("庫存數量已設為0，原輸入無效。");
    }
    if (product.value.shoeSizes.some(item => item.size === size)) {
        ElMessage.warning(`尺碼 "${size}" 已存在！`);
        return;
    }

    product.value.shoeSizes.push({ size: size, stock: Number(newShoeSize.value.stock) });
    newShoeSize.value = { size: '', stock: 0 };
};

const removeShoeSize = (indexToRemove) => {
    product.value.shoeSizes.splice(indexToRemove, 1);
};

const validateStock = (shoeSizeItem) => {
    if (shoeSizeItem.stock < 0 || shoeSizeItem.stock === null || typeof shoeSizeItem.stock === 'undefined' || isNaN(shoeSizeItem.stock)) {
        ElMessage.warning(`尺碼 "${shoeSizeItem.size}" 的庫存輸入無效，將自動更正為0。`);
        shoeSizeItem.stock = 0;
    }
};

const isSaveDisabled = computed(() => {
    const coverImageLogic = product.value.images && product.value.images.length > 0 && !product.value.mainImage;
    const invalidStock = product.value.shoeSizes.some(
        item => item.stock < 0 || item.stock === null || typeof item.stock === 'undefined' || isNaN(item.stock)
    );
    // 检查品牌名称是否已输入 (如果它是必填项)
    const brandNotEntered = !product.value.brandName;

    return coverImageLogic || invalidStock || brandNotEntered;
});


const closeModal = () => {
    emit('close');
    // isVisible 變為 false 時，其 watch 回調會執行重置邏輯
};

const handleSubmit = () => {
    for (const shoe of product.value.shoeSizes) {
        if (shoe.stock < 0 || shoe.stock === null || typeof shoe.stock === 'undefined' || isNaN(shoe.stock)) {
            ElMessage.warning(`尺碼 "${shoe.size}" 的庫存 (${shoe.stock}) 無效。請更正后保存。`);
            return;
        }
    }
    if (product.value.images.length > 0 && !product.value.mainImage) {
        ElMessage.warning("請選擇一張圖片作爲封面！");
        return;
    }

    if (!product.value.gender) {
        ElMessage.warning("請選擇適用性別！");
        return;
    }

    // 检查品牌名称是否已输入
    if (!product.value.brandName) {
        ElMessage.warning("請輸入品牌名稱！");
        return;
    }
    // 確保 product.kind 已被賦值 (正常流程中 goToFillFormStep 會處理)
    if (!product.value.kind) {
        // 再次確認，如果用戶 somehow 跳過了第一步 (理論上不可能)
        ElMessage.error("未選擇商品種類，無法保存！"); 
        currentStep.value = 'selectKind'; // 強制返回第一步
        return;
    }

    product.value.tags = tagsInput.value ? tagsInput.value.split(/[,，]/).map(tag => tag.trim()).filter(tag => tag) : [];

    const { ...productDataWithoutTempId } = product.value; 

    const productDataToSave = {
        ...productDataWithoutTempId, 
        imageFiles: product.value.images.map(img => img.file),
        shoeSizes: product.value.shoeSizes.map(s => ({...s, stock: Number(s.stock)}))
    };
    const { images, ...restOfProductData } = productDataToSave; 
    emit('save', restOfProductData);
};
</script>

<style scoped>
/* 原有样式 - 大部分不变 */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: white;
    padding: 25px 30px;
    border-radius: 8px;
    width: 60%; 
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    max-height: 90vh; 
    overflow-y: auto; 
    display: flex;
    flex-direction: column;
}

.modal-content h2 {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 1.5em;
    color: #333;
    text-align: center;
}

.form-layout-container {
    display: flex;
    gap: 20px; 
    flex-grow: 1; 
    overflow-y: hidden; 
}

.form-left-panel {
    flex: 0 0 280px; 
    padding-right: 15px; 
    border-right: 1px solid #eee; 
}

.form-right-panel {
    flex: 1; 
}

.form-group {
    margin-bottom: 18px;
}

.form-group label {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
    color: #555;
}

.form-group input[type="text"],
.form-group input[type="number"],
.form-group input[type="url"],
.form-group input[type="file"],
.form-group select,
.form-group textarea { 
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 1em;
    font-family: inherit; 
}
.form-group input[type="file"] {
    padding: 5px;
}
.form-group textarea {
    resize: vertical; 
    min-height: 80px; 
}
.readonly-field {
    background-color: #f8f9fa;
    color: #495057;
    cursor: not-allowed;
}

.form-group input:focus, 
.form-group select:focus,
.form-group textarea:focus { 
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

.image-preview-container {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 5px 0;
    max-height: 300px; 
    overflow-y: auto;
}

.image-preview-item {
    position: relative;
    border: 1px solid #eee;
    padding: 5px;
    border-radius: 4px;
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(50% - 5px); 
    box-sizing: border-box;
}

.preview-thumbnail {
    width: 100%; 
    height: 100px; 
    object-fit: cover;
    border-radius: 4px;
    margin-bottom: 5px;
}

.image-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 0.9em;
}
.cover-label {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: normal;
    margin-bottom: 0;
}
.cover-label input[type="radio"] {
    width: auto;
    margin-right: 3px;
}

.btn-remove-img {
    background-color: #ff4d4f;
    color: white;
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    cursor: pointer;
    padding: 0;
}
.btn-remove-img:hover {
    background-color: #d9363e;
}

.cover-warning {
    color: red;
    font-size: 0.9em;
    margin-top: 5px;
}

.modal-actions {
    margin-top: 25px; 
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 15px; 
    border-top: 1px solid #eee; 
}

.btn {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1em;
    font-weight: 500;
}

.btn-save {
    background-color: #28a745; 
    color: white;
}
.btn-save:hover:not(:disabled) {
    background-color: #218838;
}
.btn-save:disabled {
    background-color: #a5d6a7; 
    cursor: not-allowed;
}

.btn-cancel {
    background-color: #6c757d;
    color: white;
}
.btn-cancel:hover {
    background-color: #5a6268;
}

.btn-secondary { /* 新增 "上一步" 按鈕的樣式 */
    background-color: #f0f0f0;
    color: #333;
    border: 1px solid #ccc;
}
.btn-secondary:hover {
    background-color: #e0e0e0;
}

.shoe-size-input-group {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 10px;
}
.shoe-size-field {
    flex: 2;
}
.shoe-stock-field {
    flex: 1;
    min-width: 70px;
}
.btn-add-size {
    padding: 8px 10px;
    font-size: 0.9em;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    white-space: nowrap;
}
.btn-add-size:hover {
    background-color: #0056b3;
}

.shoe-size-list {
    margin-top: 10px;
    padding-top: 5px;
    max-height: 150px; 
    overflow-y: auto;
}
.shoe-size-list strong {
    display: block;
    margin-bottom: 5px;
    font-size: 0.9em;
}
.shoe-size-list ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}
.shoe-size-list-item {
    display: flex;
    align-items: center;
    padding: 4px 0;
    font-size: 0.9em;
    border-bottom: 1px solid #f0f0f0;
}
.shoe-size-list-item:last-child {
    border-bottom: none;
}
.shoe-size-list-stock-input {
    width: 10% !important; /* 保持原樣式 */
    padding: 4px 6px;
    font-size: 0.9em;
    text-align: right;
    border: 1px solid #ddd;
    border-radius: 3px;
    margin-left: 5px;
    margin-right: auto;
}

.btn-remove-size {
    background-color: #e74c3c;
    color: white;
    border: none;
    border-radius: 3px;
    padding: 2px 6px;
    font-size: 0.8em;
    cursor: pointer;
    margin-left: 8px;
}
.btn-remove-size:hover {
    background-color: #c0392b;
}
</style>
